import { render, staticRenderFns } from "./cityLinkage.vue?vue&type=template&id=644bd40c&scoped=true&"
import script from "./cityLinkage.vue?vue&type=script&lang=js&"
export * from "./cityLinkage.vue?vue&type=script&lang=js&"
import style0 from "./cityLinkage.vue?vue&type=style&index=0&id=644bd40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bd40c",
  null
  
)

export default component.exports